

// // // // // // // // // // // export default LeftSidebar;
// // // // // // // // // // import React, { useState } from "react";
// // // // // // // // // // import { CheckCircle } from "lucide-react";
// // // // // // // // // // import Modal from "../ImageModal"; // tıklayınca büyüyen resim için modal

// // // // // // // // // // const features = [
// // // // // // // // // //   "Ücretsiz Servis",
// // // // // // // // // //   "Aynı Gün Teslim",
// // // // // // // // // //   "Profesyonel Ekip",
// // // // // // // // // //   "Organik Deterjan",
// // // // // // // // // //   "Memnuniyet Garantisi",
// // // // // // // // // // ];

// // // // // // // // // // const galleryImages = [
// // // // // // // // // //   "/images/aktar/fabrika içi/Fotoram.io (6).png",
// // // // // // // // // //   "/images/aktar/fabrika içi/Fotoram.io (20).png",
// // // // // // // // // //   "/images/aktar/fabrika içi/Fotoram.io (21).png",
// // // // // // // // // //   "/images/aktar/fabrika içi/Fotoram.io (22).png",
// // // // // // // // // //   "/images/aktar/fabrika içi/Fotoram.io (23).png",
// // // // // // // // // // ];

// // // // // // // // // // const LeftSidebar = () => {
// // // // // // // // // //   const [open, setOpen] = useState(false);
// // // // // // // // // //   const [selectedImage, setSelectedImage] = useState(null);

// // // // // // // // // //   return (
// // // // // // // // // //     <aside className="space-y-6">
// // // // // // // // // //       {/* Ana Fotoğraf */}
      

// // // // // // // // // //       {/* Ana fotoğraf modal */}
// // // // // // // // // //       {open && <Modal image="/images/tesis.jpg" onClose={() => setOpen(false)} />}

// // // // // // // // // //       {/* Neden Biz */}
// // // // // // // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // // // // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">Neden Bizi Tercih Etmelisiniz?</h3>
// // // // // // // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // // // // // // //           {features.map((item, index) => (
// // // // // // // // // //             <li key={index} className="flex items-center gap-2">
// // // // // // // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // // // // // // //               {item}
// // // // // // // // // //             </li>
// // // // // // // // // //           ))}
// // // // // // // // // //         </ul>
// // // // // // // // // //       </div>

// // // // // // // // // //       {/* Fabrika Foto Galerisi */}
// // // // // // // // // //       {/* Fabrika Foto Galerisi */}
// // // // // // // // // // <div>
// // // // // // // // // //   <h3 className="text-lg font-semibold mb-2 text-gray-800">Fabrika İçi Görseller</h3>
// // // // // // // // // //   <div className="grid grid-cols-2 gap-3">
// // // // // // // // // //     {galleryImages.map((src, i) => (
// // // // // // // // // //       <img
// // // // // // // // // //         key={i}
// // // // // // // // // //         src={src}
// // // // // // // // // //         alt={`Fabrika ${i}`}
// // // // // // // // // //         className="cursor-pointer rounded-lg border hover:scale-105 transition aspect-square object-cover"
// // // // // // // // // //         onClick={() => setSelectedImage(src)}
// // // // // // // // // //       />
// // // // // // // // // //     ))}
// // // // // // // // // //   </div>
// // // // // // // // // // </div>


// // // // // // // // // //       {/* Galeri modalı */}
// // // // // // // // // //       {selectedImage && (
// // // // // // // // // //         <Modal image={selectedImage} onClose={() => setSelectedImage(null)} />
// // // // // // // // // //       )}
// // // // // // // // // //     </aside>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default LeftSidebar;
// // // // // // // // // import React, { useState } from "react";
// // // // // // // // // import { CheckCircle } from "lucide-react";
// // // // // // // // // import Modal from "../ImageModal";

// // // // // // // // // const features = [
// // // // // // // // //   "Ücretsiz Servis",
// // // // // // // // //   "Aynı Gün Teslim",
// // // // // // // // //   "Profesyonel Ekip",
// // // // // // // // //   "Organik Deterjan",
// // // // // // // // //   "Memnuniyet Garantisi",
// // // // // // // // // ];

// // // // // // // // // const imageData = {
// // // // // // // // //   "Halı Yıkama": [
// // // // // // // // //     "/images/halilar/h1.png",
// // // // // // // // //     "/images/halilar/h2.png",
// // // // // // // // //     "/images/halilar/h3.png",
// // // // // // // // //     "/images/halilar/h4.png",
// // // // // // // // //     "/images/halilar/h5.png",
// // // // // // // // //     "/images/halilar/h6.png",
// // // // // // // // //     "/images/halilar/h7.png",
// // // // // // // // //     "/images/halilar/h8.png",
// // // // // // // // //     "/images/halilar/h9.webp",
// // // // // // // // //     "/images/halilar/h10.png",
// // // // // // // // //   ],
// // // // // // // // //   "Koltuk Yıkama": [
// // // // // // // // //     "/images/koltuk/k1.png",
// // // // // // // // //     "/images/koltuk/k2.png",
// // // // // // // // //     "/images/koltuk/k3.png",
// // // // // // // // //     "/images/koltuk/k4.png",
// // // // // // // // //   ],
// // // // // // // // //   "Diğer": [
// // // // // // // // //     "/images/diger/d1.png",
// // // // // // // // //     "/images/diger/d2.png",
// // // // // // // // //   ],
// // // // // // // // // };

// // // // // // // // // const LeftSidebar = () => {
// // // // // // // // //   const [selectedCategory, setSelectedCategory] = useState("Halı Yıkama");
// // // // // // // // //   const [selectedImage, setSelectedImage] = useState(null);

// // // // // // // // //   return (
// // // // // // // // //     <aside className="space-y-6">
// // // // // // // // //       {/* Neden Biz */}
// // // // // // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // // // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">Neden Bizi Tercih Etmelisiniz?</h3>
// // // // // // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // // // // // //           {features.map((item, index) => (
// // // // // // // // //             <li key={index} className="flex items-center gap-2">
// // // // // // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // // // // // //               {item}
// // // // // // // // //             </li>
// // // // // // // // //           ))}
// // // // // // // // //         </ul>
// // // // // // // // //       </div>

// // // // // // // // //       {/* Kategori Seçimi */}
// // // // // // // // //       <div>
// // // // // // // // //         <h3 className="text-lg font-semibold mb-2 text-gray-800">Galeri Kategorileri</h3>
// // // // // // // // //         <div className="flex flex-wrap gap-2 mb-4">
// // // // // // // // //           {Object.keys(imageData).map((category) => (
// // // // // // // // //             <button
// // // // // // // // //               key={category}
// // // // // // // // //               onClick={() => setSelectedCategory(category)}
// // // // // // // // //               className={`px-3 py-1 rounded-full border text-sm ${selectedCategory === category ? "bg-green-700 text-white" : "bg-white text-gray-800 border-gray-300"}`}
// // // // // // // // //             >
// // // // // // // // //               {category}
// // // // // // // // //             </button>
// // // // // // // // //           ))}
// // // // // // // // //         </div>

// // // // // // // // //         <div className="grid grid-cols-2 gap-3">
// // // // // // // // //           {imageData[selectedCategory].map((src, i) => (
// // // // // // // // //             <img
// // // // // // // // //               key={i}
// // // // // // // // //               src={src}
// // // // // // // // //               alt={`${selectedCategory} ${i}`}
// // // // // // // // //               className="cursor-pointer rounded-lg border hover:scale-105 transition aspect-square object-cover"
// // // // // // // // //               onClick={() => setSelectedImage(src)}
// // // // // // // // //             />
// // // // // // // // //           ))}
// // // // // // // // //         </div>
// // // // // // // // //       </div>

// // // // // // // // //       {/* Modal */}
// // // // // // // // //       {selectedImage && (
// // // // // // // // //         <Modal image={selectedImage} onClose={() => setSelectedImage(null)} />
// // // // // // // // //       )}
// // // // // // // // //     </aside>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default LeftSidebar;
// // // // // // // // import React, { useState } from "react";
// // // // // // // // import { CheckCircle } from "lucide-react";
// // // // // // // // import Modal from "../ImageModal"; // tıklayınca büyüyen resim için modal

// // // // // // // // const features = [
// // // // // // // //   "Ücretsiz Servis",
// // // // // // // //   "Aynı Gün Teslim",
// // // // // // // //   "Profesyonel Ekip",
// // // // // // // //   "Organik Deterjan",
// // // // // // // //   "Memnuniyet Garantisi",
// // // // // // // // ];

// // // // // // // // const imageCategories = {
// // // // // // // //   "Halı Yıkama": [
// // // // // // // //     "/images/aktar/hali/hali1.png",
// // // // // // // //     "/images/aktar/hali/hali2.png",
// // // // // // // //     "/images/aktar/hali/hali3.png",
// // // // // // // //     "/images/aktar/hali/hali4.png",
// // // // // // // //     "/images/aktar/hali/hali5.png",
// // // // // // // //     "/images/aktar/hali/hali6.png",
// // // // // // // //     "/images/aktar/hali/hali7.png",
// // // // // // // //     "/images/aktar/hali/hali8.png",
// // // // // // // //     "/images/aktar/hali/hali9.webp",
// // // // // // // //     "/images/aktar/hali/hali10.png"
// // // // // // // //   ],
// // // // // // // //   "Koltuk Yıkama": [
// // // // // // // //     "/images/aktar/koltuk/koltuk1.png",
// // // // // // // //     "/images/aktar/koltuk/koltuk2.png",
// // // // // // // //     "/images/aktar/koltuk/koltuk3.png",
// // // // // // // //     "/images/aktar/koltuk/koltuk4.png",
// // // // // // // //     "/images/aktar/koltuk/koltuk5.png"
// // // // // // // //   ],
// // // // // // // //   "Diğer": [
// // // // // // // //     "/images/aktar/diger/diger1.png",
// // // // // // // //     "/images/aktar/diger/diger2.png",
// // // // // // // //     "/images/aktar/diger/diger3.png"
// // // // // // // //   ]
// // // // // // // // };

// // // // // // // // const LeftSidebar = () => {
// // // // // // // //   const [selectedImage, setSelectedImage] = useState(null);
// // // // // // // //   const [selectedCategory, setSelectedCategory] = useState("Halı Yıkama");

// // // // // // // //   return (
// // // // // // // //     <aside className="space-y-6">
// // // // // // // //       {/* Neden Biz */}
// // // // // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">Neden Bizi Tercih Etmelisiniz?</h3>
// // // // // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // // // // //           {features.map((item, index) => (
// // // // // // // //             <li key={index} className="flex items-center gap-2">
// // // // // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // // // // //               {item}
// // // // // // // //             </li>
// // // // // // // //           ))}
// // // // // // // //         </ul>
// // // // // // // //       </div>

// // // // // // // //       {/* Kategori Seçimi */}
// // // // // // // //       <div className="flex gap-3 flex-wrap">
// // // // // // // //         {Object.keys(imageCategories).map((cat) => (
// // // // // // // //           <button
// // // // // // // //             key={cat}
// // // // // // // //             onClick={() => setSelectedCategory(cat)}
// // // // // // // //             className={`px-4 py-2 rounded-xl text-sm font-medium border transition shadow ${
// // // // // // // //               selectedCategory === cat ? "bg-green-600 text-white" : "bg-white text-gray-800"
// // // // // // // //             }`}
// // // // // // // //           >
// // // // // // // //             {cat}
// // // // // // // //           </button>
// // // // // // // //         ))}
// // // // // // // //       </div>

// // // // // // // //       {/* Seçilen Kategoriye Ait Görseller */}
// // // // // // // //       <div>
// // // // // // // //         <h3 className="text-lg font-semibold mb-2 text-gray-800">{selectedCategory} Fotoğrafları</h3>
// // // // // // // //         <div className="grid grid-cols-2 gap-3">
// // // // // // // //           {imageCategories[selectedCategory].map((src, i) => (
// // // // // // // //             <img
// // // // // // // //               key={i}
// // // // // // // //               src={src}
// // // // // // // //               alt={`${selectedCategory} ${i}`}
// // // // // // // //               className="cursor-pointer rounded-lg border hover:scale-105 transition aspect-square object-cover"
// // // // // // // //               onClick={() => setSelectedImage(src)}
// // // // // // // //             />
// // // // // // // //           ))}
// // // // // // // //         </div>
// // // // // // // //       </div>

// // // // // // // //       {/* Modal */}
// // // // // // // //       {selectedImage && (
// // // // // // // //         <Modal image={selectedImage} onClose={() => setSelectedImage(null)} />
// // // // // // // //       )}
// // // // // // // //     </aside>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default LeftSidebar;
// // // // // // // import React, { useState } from "react";
// // // // // // // import { CheckCircle } from "lucide-react";
// // // // // // // import Modal from "../ImageModal"; // tıklayınca büyüyen resim için modal

// // // // // // // const features = [
// // // // // // //   "Ücretsiz Servis",
// // // // // // //   "Aynı Gün Teslim",
// // // // // // //   "Profesyonel Ekip",
// // // // // // //   "Organik Deterjan",
// // // // // // //   "Memnuniyet Garantisi",
// // // // // // // ];

// // // // // // // const imageCategories = {
// // // // // // //   "Halı Yıkama": [
// // // // // // //     "/images/aktar/hali/hali1.png",
// // // // // // //     "/images/aktar/hali/hali2.png",
// // // // // // //     "/images/aktar/hali/hali3.png",
// // // // // // //     "/images/aktar/hali/hali4.png",
// // // // // // //     "/images/aktar/hali/hali5.png",
// // // // // // //     "/images/aktar/hali/hali6.png",
// // // // // // //     "/images/aktar/hali/hali7.png",
// // // // // // //     "/images/aktar/hali/hali8.png",
// // // // // // //     "/images/aktar/hali/hali9.webp",
// // // // // // //     "/images/aktar/hali/hali10.png",
// // // // // // //   ],
// // // // // // //   "Koltuk Yıkama": [
// // // // // // //     "/images/aktar/koltuk/koltuk1.png",
// // // // // // //     "/images/aktar/koltuk/koltuk2.png",
// // // // // // //     "/images/aktar/koltuk/koltuk3.png",
// // // // // // //     "/images/aktar/koltuk/koltuk4.png",
// // // // // // //     "/images/aktar/koltuk/koltuk5.png",
// // // // // // //   ],
// // // // // // //   "Diğer": [
// // // // // // //     "/images/aktar/diger/diger1.png",
// // // // // // //     "/images/aktar/diger/diger2.png",
// // // // // // //     "/images/aktar/diger/diger3.png",
// // // // // // //   ],
// // // // // // // };

// // // // // // // const LeftSidebar = () => {
// // // // // // //   const [selectedImage, setSelectedImage] = useState(null);
// // // // // // //   const [selectedCategory, setSelectedCategory] = useState(null);

// // // // // // //   return (
// // // // // // //     <aside className="space-y-6">
// // // // // // //       {/* Neden Biz Kutusu */}
// // // // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">
// // // // // // //           Neden Bizi Tercih Etmelisiniz?
// // // // // // //         </h3>
// // // // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // // // //           {features.map((item, index) => (
// // // // // // //             <li key={index} className="flex items-center gap-2">
// // // // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // // // //               {item}
// // // // // // //             </li>
// // // // // // //           ))}
// // // // // // //         </ul>
// // // // // // //       </div>

// // // // // // //       {/* Kategori Kutuları */}
// // // // // // //       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// // // // // // //         {Object.keys(imageCategories).map((cat) => (
// // // // // // //           <div
// // // // // // //             key={cat}
// // // // // // //             onClick={() => setSelectedCategory(cat)}
// // // // // // //             className={`border border-gray-300 rounded-xl p-6 text-center shadow-md cursor-pointer transition-all hover:bg-green-50 ${
// // // // // // //               selectedCategory === cat ? "bg-green-100 border-green-500" : "bg-white"
// // // // // // //             }`}
// // // // // // //           >
// // // // // // //             <p className="text-base font-semibold text-gray-800">{cat}</p>
// // // // // // //           </div>
// // // // // // //         ))}
// // // // // // //       </div>

// // // // // // //       {/* Fotoğraf Galerisi */}
// // // // // // //       {selectedCategory && (
// // // // // // //         <div className="pt-2">
// // // // // // //           <h3 className="text-lg font-bold mb-3 text-gray-800">
// // // // // // //             {selectedCategory} Fotoğrafları
// // // // // // //           </h3>
// // // // // // //           <div className="grid grid-cols-2 gap-3">
// // // // // // //             {imageCategories[selectedCategory].map((src, i) => (
// // // // // // //               <img
// // // // // // //                 key={i}
// // // // // // //                 src={src}
// // // // // // //                 alt={`${selectedCategory} ${i}`}
// // // // // // //                 className="cursor-pointer rounded-lg border hover:scale-105 transition-transform aspect-square object-cover"
// // // // // // //                 onClick={() => setSelectedImage(src)}
// // // // // // //               />
// // // // // // //             ))}
// // // // // // //           </div>
// // // // // // //         </div>
// // // // // // //       )}

// // // // // // //       {/* Modal */}
// // // // // // //       {selectedImage && <Modal image={selectedImage} onClose={() => setSelectedImage(null)} />}
// // // // // // //     </aside>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default LeftSidebar;
// // // // // // import React, { useState } from "react";
// // // // // // import { CheckCircle } from "lucide-react";
// // // // // // import ImageGalleryModal from "./ImageGalleryModal"; // dosya ismi uyumluysa

// // // // // // const features = [
// // // // // //   "Ücretsiz Servis",
// // // // // //   "Aynı Gün Teslim",
// // // // // //   "Profesyonel Ekip",
// // // // // //   "Organik Deterjan",
// // // // // //   "Memnuniyet Garantisi",
// // // // // // ];

// // // // // // const imageCategories = {
// // // // // //   "Halı Yıkama": [
// // // // // //     "/images/aktar/hali/hali1.png",
// // // // // //     "/images/aktar/hali/hali2.png",
// // // // // //     "/images/aktar/hali/hali3.png",
// // // // // //     "/images/aktar/hali/hali4.png",
// // // // // //     "/images/aktar/hali/hali5.png",
// // // // // //   ],
// // // // // //   "Koltuk Yıkama": [
// // // // // //     "/images/aktar/koltuk/koltuk1.png",
// // // // // //     "/images/aktar/koltuk/koltuk2.png",
// // // // // //     "/images/aktar/koltuk/koltuk3.png",
// // // // // //     "/images/aktar/koltuk/koltuk4.png",
// // // // // //   ],
// // // // // //   "Diğer": [
// // // // // //     "/images/aktar/diger/diger1.png",
// // // // // //     "/images/aktar/diger/diger2.png",
// // // // // //     "/images/aktar/diger/diger3.png",
// // // // // //   ],
// // // // // // };

// // // // // // const LeftSidebar = () => {
// // // // // //   const [modalVisible, setModalVisible] = useState(false);
// // // // // //   const [selectedCategory, setSelectedCategory] = useState(null);

// // // // // //   const handleOpen = (cat) => {
// // // // // //     setSelectedCategory(cat);
// // // // // //     setModalVisible(true);
// // // // // //   };

// // // // // //   return (
// // // // // //     <aside className="space-y-6">
// // // // // //       {/* Neden Biz */}
// // // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">Neden Bizi Tercih Etmelisiniz?</h3>
// // // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // // //           {features.map((item, index) => (
// // // // // //             <li key={index} className="flex items-center gap-2">
// // // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // // //               {item}
// // // // // //             </li>
// // // // // //           ))}
// // // // // //         </ul>
// // // // // //       </div>

// // // // // //       {/* Kategori Kutuları */}
// // // // // //       <div className="flex flex-col gap-4">
// // // // // //         {Object.keys(imageCategories).map((cat, index) => (
// // // // // //           <div
// // // // // //             key={index}
// // // // // //             onClick={() => handleOpen(cat)}
// // // // // //             className="bg-white border border-gray-300 rounded-xl shadow-lg p-6 text-center cursor-pointer hover:bg-green-50 transition"
// // // // // //             style={{
// // // // // //               minHeight: "130px",
// // // // // //               display: "flex",
// // // // // //               alignItems: "center",
// // // // // //               justifyContent: "center",
// // // // // //             }}
// // // // // //           >
// // // // // //             <span className="text-lg font-semibold text-gray-800">{cat}</span>
// // // // // //           </div>
// // // // // //         ))}
// // // // // //       </div>

// // // // // //       {/* Modal */}
// // // // // //       {modalVisible && selectedCategory && (
// // // // // //         <ImageGalleryModal
// // // // // //           title={selectedCategory}
// // // // // //           images={imageCategories[selectedCategory]}
// // // // // //           onClose={() => setModalVisible(false)}
// // // // // //         />
// // // // // //       )}
// // // // // //     </aside>
// // // // // //   );
// // // // // // };

// // // // // // export default LeftSidebar;
// // // // // import React, { useState } from "react";
// // // // // import { CheckCircle } from "lucide-react";
// // // // // import ImageGalleryModal from "./ImageGalleryModal";

// // // // // const features = [
// // // // //   "Ücretsiz Servis",
// // // // //   "Aynı Gün Teslim",
// // // // //   "Profesyonel Ekip",
// // // // //   "Organik Deterjan",
// // // // //   "Memnuniyet Garantisi",
// // // // // ];

// // // // // const imageCategories = {
// // // // //   "Halı Yıkama": [
// // // // //     "/images/aktar/hali/hali1.png",
// // // // //     "/images/aktar/hali/hali2.png",
// // // // //     "/images/aktar/hali/hali3.png",
// // // // //   ],
// // // // //   "Koltuk Yıkama": [
// // // // //     "/images/aktar/koltuk/koltuk1.png",
// // // // //     "/images/aktar/koltuk/koltuk2.png",
// // // // //   ],
// // // // //   "Diğer": [
// // // // //     "/images/aktar/diger/diger1.png",
// // // // //     "/images/aktar/diger/diger2.png",
// // // // //   ],
// // // // // };

// // // // // const categoryVisuals = {
// // // // //   "Halı Yıkama": "/images/cat1.png",
// // // // //   "Koltuk Yıkama": "/images/cat2.png",
// // // // //   "Diğer": "/images/cat3.png",
// // // // // };

// // // // // const LeftSidebar = () => {
// // // // //   const [modalVisible, setModalVisible] = useState(false);
// // // // //   const [selectedCategory, setSelectedCategory] = useState(null);

// // // // //   const handleOpen = (cat) => {
// // // // //     setSelectedCategory(cat);
// // // // //     setModalVisible(true);
// // // // //   };

// // // // //   return (
// // // // //     <aside className="space-y-6">
// // // // //       {/* Neden Biz Kutusu */}
// // // // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // // // //         <h3 className="text-lg font-semibold text-green-700 mb-2">Neden Bizi Tercih Etmelisiniz?</h3>
// // // // //         <ul className="text-sm text-gray-700 space-y-2">
// // // // //           {features.map((item, index) => (
// // // // //             <li key={index} className="flex items-center gap-2">
// // // // //               <CheckCircle size={16} className="text-green-600" />
// // // // //               {item}
// // // // //             </li>
// // // // //           ))}
// // // // //         </ul>
// // // // //       </div>

// // // // //       {/* Kategori Rozet Stili Kutular */}
// // // // //       <div className="flex flex-col gap-4">
// // // // //         {Object.keys(imageCategories).map((cat, index) => (
// // // // //           <div
// // // // //             key={index}
// // // // //             onClick={() => handleOpen(cat)}
// // // // //             className="relative bg-white border border-gray-300 rounded-xl shadow-lg cursor-pointer overflow-hidden transition hover:scale-[1.02]"
// // // // //             style={{
// // // // //               height: "130px",
// // // // //             }}
// // // // //           >
// // // // //             <img
// // // // //               src={categoryVisuals[cat]}
// // // // //               alt={cat}
// // // // //               className="absolute inset-0 w-full h-full object-contain opacity-100"
// // // // //             />
// // // // //             <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center">
// // // // //               <span className="text-lg font-bold text-gray-800">{cat}</span>
// // // // //             </div>
// // // // //           </div>
// // // // //         ))}
// // // // //       </div>

// // // // //       {/* Modal */}
// // // // //       {modalVisible && selectedCategory && (
// // // // //         <ImageGalleryModal
// // // // //           title={selectedCategory}
// // // // //           images={imageCategories[selectedCategory]}
// // // // //           onClose={() => setModalVisible(false)}
// // // // //         />
// // // // //       )}
// // // // //     </aside>
// // // // //   );
// // // // // };

// // // // // export default LeftSidebar;
// // // // import React, { useState } from "react";
// // // // import ImageGalleryModal from "./ImageGalleryModal";

// // // // const imageCategories = {
// // // //   "Halı Yıkama": [
// // // //     "/images/aktar/hali/hali1.png",
// // // //     "/images/aktar/hali/hali2.png",
// // // //     "/images/aktar/hali/hali3.png",
// // // //   ],
// // // //   "Koltuk Yıkama": [
// // // //     "/images/aktar/koltuk/koltuk1.png",
// // // //     "/images/aktar/koltuk/koltuk2.png",
// // // //   ],
// // // //   "Diğer": [
// // // //     "/images/aktar/diger/diger1.png",
// // // //     "/images/aktar/diger/diger2.png",
// // // //   ],
// // // // };

// // // // const categoryVisuals = {
// // // //   "Halı Yıkama": "/images/cat1.png",
// // // //   "Koltuk Yıkama": "/images/cat2.png",
// // // //   "Diğer": "/images/cat3.png",
// // // // };

// // // // const CategoryBadges = () => {
// // // //   const [modalVisible, setModalVisible] = useState(false);
// // // //   const [selectedCategory, setSelectedCategory] = useState(null);

// // // //   const handleOpen = (cat) => {
// // // //     setSelectedCategory(cat);
// // // //     setModalVisible(true);
// // // //   };

// // // //   return (
// // // //     <div className="flex flex-col items-center gap-4">
// // // //       {Object.keys(imageCategories).map((cat, index) => (
// // // //         <div
// // // //           key={index}
// // // //           onClick={() => handleOpen(cat)}
// // // //           className="relative w-95 sm:w-72 md:w-80 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
// // // //           style={{ height: "auto" }}
// // // //         >
// // // //           <img
// // // //             src={categoryVisuals[cat]}
// // // //             alt={cat}
// // // //             className="w-full h-auto object-contain"
// // // //           />
// // // //           <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center">
// // // //             <span className="text-lg font-bold text-gray-800">{cat}</span>
// // // //           </div>
// // // //         </div>
// // // //       ))}

// // // //       {/* Modal */}
// // // //       {modalVisible && selectedCategory && (
// // // //         <ImageGalleryModal
// // // //           title={selectedCategory}
// // // //           images={imageCategories[selectedCategory]}
// // // //           onClose={() => setModalVisible(false)}
// // // //         />
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default CategoryBadges;
// // // import React, { useState } from "react";
// // // import { CheckCircle } from "lucide-react";
// // // import ImageGalleryModal from "./ImageGalleryModal";

// // // const features = [
// // //   "Ücretsiz Servis",
// // //   "Aynı Gün Teslim",
// // //   "Profesyonel Ekip",
// // //   "Organik Deterjan",
// // //   "Memnuniyet Garantisi",
// // // ];

// // // const imageCategories = {
// // //   "Halı Yıkama": [
// // //     "/images/aktar/hali/hali1.png",
// // //     "/images/aktar/hali/hali2.png",
// // //     "/images/aktar/hali/hali3.png",
// // //   ],
// // //   "Koltuk Yıkama": [
// // //     "/images/aktar/koltuk/koltuk1.png",
// // //     "/images/aktar/koltuk/koltuk2.png",
// // //   ],
// // //   "Diğer": [
// // //     "/images/aktar/diger/diger1.png",
// // //     "/images/aktar/diger/diger2.png",
// // //   ],
// // // };

// // // const categoryVisuals = {
// // //   "Halı Yıkama": "/images/cat1.png",
// // //   "Koltuk Yıkama": "/images/cat2.png",
// // //   "Diğer": "/images/cat3.png",
// // // };

// // // const LeftSidebar = () => {
// // //   const [modalVisible, setModalVisible] = useState(false);
// // //   const [selectedCategory, setSelectedCategory] = useState(null);

// // //   const handleOpen = (cat) => {
// // //     setSelectedCategory(cat);
// // //     setModalVisible(true);
// // //   };

// // //   return (
// // //     <aside className="space-y-6">
// // //       {/* ✅ Neden Biz Kutusu */}
// // //       <div className="bg-white border border-gray-200 rounded-xl p-4 shadow space-y-3">
// // //         <h3 className="text-lg font-semibold text-green-700 mb-2">
// // //           Neden Bizi Tercih Etmelisiniz?
// // //         </h3>
// // //         <ul className="text-sm text-gray-700 space-y-2">
// // //           {features.map((item, index) => (
// // //             <li key={index} className="flex items-center gap-2">
// // //               <CheckCircle size={16} className="text-green-600" />
// // //               {item}
// // //             </li>
// // //           ))}
// // //         </ul>
// // //       </div>

// // //       {/* ✅ Kategori Rozet Kutuları */}
// // //       <div className="flex flex-col items-center gap-4">
// // //         {Object.keys(imageCategories).map((cat, index) => (
// // //           <div
// // //             key={index}
// // //             onClick={() => handleOpen(cat)}
// // //             className="relative w-95 sm:w-72 md:w-80 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
// // //           >
// // //             <img
// // //               src={categoryVisuals[cat]}
// // //               alt={cat}
// // //               className="w-full h-auto object-contain"
// // //             />
// // //             <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center">
// // //               <span className="text-lg font-bold text-gray-800">{cat}</span>
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>

// // //       {/* ✅ Modal */}
// // //       {modalVisible && selectedCategory && (
// // //         <ImageGalleryModal
// // //           title={selectedCategory}
// // //           images={imageCategories[selectedCategory]}
// // //           onClose={() => setModalVisible(false)}
// // //         />
// // //       )}
// // //     </aside>
// // //   );
// // // };

// // // export default LeftSidebar;
// // import React, { useState } from "react";
// // import { CheckCircle } from "lucide-react";
// // import ImageGalleryModal from "./ImageGalleryModal";

// // const features = [
// //   "10 Yıllık Tecrübe",
// //   "%100 Garanti",
// //   "Adresten Alım Teslim",
// //   "2-3 Gün İçinde Teslim",
// //   "Yerinde Koltuk Yıkama",
// //   "Organik Deterjan Kullanımı",
// //   "Yorgan ve Battaniye Temizliği",
// //   "Ücretsiz Servis Hizmeti",
// //   "Tüm Halı Türlerine Uygun Yıkama",
// //   "Halı Tamiri ve Overlok",
// //   "Kısa Sürede Kuruma",
// //   "Hijyenik Tam Otomatik Yıkama",
// //   "Perde Yıkama Hizmeti",
// //   "Antibakteriyel Ürün Kullanımı",
// //   "Yerinde Profesyonel Hizmet",
// //   "Koşulsuz Müşteri Memnuniyeti"
// // ];

// // const imageCategories = {
// //   "Halı Yıkama": [
// //     "/images/aktar/hali/hali1.png",
// //     "/images/aktar/hali/hali2.png",
// //     "/images/aktar/hali/hali3.png",
// //   ],
// //   "Koltuk Yıkama": [
// //     "/images/aktar/koltuk/koltuk1.png",
// //     "/images/aktar/koltuk/koltuk2.png",
// //   ],
// //   "Diğer": [
// //     "/images/aktar/diger/diger1.png",
// //     "/images/aktar/diger/diger2.png",
// //   ],
// // };

// // const categoryVisuals = {
// //   "Halı Yıkama": "/images/cat1.png",
// //   "Koltuk Yıkama": "/images/cat2.png",
// //   "Diğer": "/images/cat3.png",
// // };

// // const LeftSidebar = () => {
// //   const [modalVisible, setModalVisible] = useState(false);
// //   const [selectedCategory, setSelectedCategory] = useState(null);

// //   const handleOpen = (cat) => {
// //     setSelectedCategory(cat);
// //     setModalVisible(true);
// //   };

// //   return (
// //     <aside className="space-y-6">
// //       {/* ✅ Neden Biz - FAQBox'a eşit 16 madde */}
// //       <div className="bg-gray-50 rounded-xl p-6 shadow border space-y-4">
// //         <h3 className="text-lg font-semibold text-gray-800">
// //           Neden Bizi Tercih Etmelisiniz?
// //         </h3>
// //         <ul className="space-y-3">
// //           {features.map((item, i) => (
// //             <li key={i} className="flex items-start gap-3">
// //               <CheckCircle size={20} className="text-green-600 mt-1" />
// //               <span className="text-sm text-gray-700">{item}</span>
// //             </li>
// //           ))}
// //         </ul>
// //       </div>

// //       {/* ✅ Kategori Kutuları - Görselli, modal tetikli */}
// //       <div className="flex flex-col items-center gap-4">
// //         {Object.keys(imageCategories).map((cat, index) => (
// //           <div
// //             key={index}
// //             onClick={() => handleOpen(cat)}
// //             className="relative w-95 sm:w-72 md:w-80 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
// //           >
// //             <img
// //               src={categoryVisuals[cat]}
// //               alt={cat}
// //               className="w-full h-auto object-contain"
// //             />
// //             <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center">
// //               <span className="text-lg font-bold text-gray-800">{cat}</span>
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       {/* ✅ Modal */}
// //       {modalVisible && selectedCategory && (
// //         <ImageGalleryModal
// //           title={selectedCategory}
// //           images={imageCategories[selectedCategory]}
// //           onClose={() => setModalVisible(false)}
// //         />
// //       )}
// //     </aside>
// //   );
// // };

// // export default LeftSidebar;
// import React, { useState } from "react";
// import { CheckCircle } from "lucide-react";
// import ImageGalleryModal from "./ImageGalleryModal";

// const features = [
//   "10 Yıllık Tecrübe",
//   "%100 Garanti",
//   "Adresten Alım Teslim",
//   "2-3 Gün İçinde Teslim",
//   "Yerinde Koltuk Yıkama",
//   "Organik Deterjan Kullanımı",
//   "Yorgan ve Battaniye Temizliği",
//   "Ücretsiz Servis Hizmeti",
//   "Tüm Halı Türlerine Uygun Yıkama",
//   "Halı Tamiri ve Overlok",
//   "Kısa Sürede Kuruma",
//   "Hijyenik Tam Otomatik Yıkama",
//   "Perde Yıkama Hizmeti",
//   "Antibakteriyel Ürün Kullanımı",
//   "Yerinde Profesyonel Hizmet",
//   "Koşulsuz Müşteri Memnuniyeti"
// ];

// const imageCategories = {
//   "Halı Yıkama": [
//     "/images/aktar/hali/hali1.png",
//     "/images/aktar/hali/hali2.png",
//     "/images/aktar/hali/hali3.png",
//   ],
//   "Koltuk Yıkama": [
//     "/images/aktar/koltuk/koltuk1.png",
//     "/images/aktar/koltuk/koltuk2.png",
//   ],
//   "Diğer": [
//     "/images/aktar/diger/diger1.png",
//     "/images/aktar/diger/diger2.png",
//   ],
// };

// const categoryVisuals = {
//   "Halı Yıkama": "/images/cat1.png",
//   "Koltuk Yıkama": "/images/cat2.png",
//   "Diğer": "/images/cat3.png",
// };

// const LeftSidebar = () => {
//   const [modalVisible, setModalVisible] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);

//   const handleOpen = (cat) => {
//     setSelectedCategory(cat);
//     setModalVisible(true);
//   };

//   return (
//     <aside className="space-y-6">
//       {/* ✅ Siyah zemin, beyaz yazı kutusu */}
//       <div className="bg-black border border-gray-200 rounded-xl shadow p-4 w-full">
//         <h3 className="text-lg font-semibold text-[#222fe9e3] ">
//           Neden Bizi Tercih Etmelisiniz?
//         </h3>
//         <ul className="space-y-2.5 text-sm text-white">
//           {features.map((item, i) => (
//             <li key={i} className="flex items-start gap-3">
//               <CheckCircle size={20} className="text-green-500 mt-1" />
//               <span>{item}</span>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* ✅ Kategori Kutuları (görselli modal açılır) */}
//       <div className="flex flex-col items-center gap-4">
//         {Object.keys(imageCategories).map((cat, index) => (
//           <div
//             key={index}
//             onClick={() => handleOpen(cat)}
//             className="relative w-85 sm:w-65 md:w-70 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
//           >
//             <img
//               src={categoryVisuals[cat]}
//               alt={cat}
//               className="w-full h-auto object-contain"
//             />
//             <div className="absolute inset-0 bg-white bg-opacity-10 flex items-center justify-center">
//               <span className="text-lg font-bold text-gray-800">{cat}</span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ✅ Modal */}
//       {modalVisible && selectedCategory && (
//         <ImageGalleryModal
//           title={selectedCategory}
//           images={imageCategories[selectedCategory]}
//           onClose={() => setModalVisible(false)}
//         />
//       )}
//     </aside>
//   );
// };

// export default LeftSidebar;
import React from "react";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom"; // nextjs'de useRouter

const features = [
  "10 Yıllık Tecrübe",
  "%100 Garanti",
  "Adresten Alım Teslim",
  "2-3 Gün İçinde Teslim",
  "Yerinde Koltuk Yıkama",
  "Organik Deterjan Kullanımı",
  "Yorgan ve Battaniye Temizliği",
  "Ücretsiz Servis Hizmeti",
  "Tüm Halı Türlerine Uygun Yıkama",
  "Halı Tamiri ve Overlok",
  "Kısa Sürede Kuruma",
  "Hijyenik Tam Otomatik Yıkama",
  "Perde Yıkama Hizmeti",
  "Antibakteriyel Ürün Kullanımı",
  "Yerinde Profesyonel Hizmet",
  "Koşulsuz Müşteri Memnuniyeti"
];

const categoryVisuals = {
  "Halı Yıkama": "/images/cat1.png",
  "Koltuk Yıkama": "/images/cat2.png",
  "Videolar": "/images/cat3.png",
};

const slugify = (str) => str.toLowerCase().replace(/\s+/g, "-");

const LeftSidebar = () => {
  const navigate = useNavigate(); // Next.js kullanıyorsan useRouter().push()

  const handleOpen = (cat) => {
    const slug = slugify(cat); // örnek: "Halı Yıkama" → "hali-yikama"
    navigate(`/galeri/${slug}`);
  };

  return (
    <aside className="space-y-6">
      <div className="bg-black border border-gray-200 rounded-xl shadow p-4 w-full">
        <h3 className="text-lg font-semibold text-[#222fe9e3]">
          Neden Bizi Tercih Etmelisiniz?
        </h3>
        <ul className="space-y-2.5 text-sm text-white">
          {features.map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-500 mt-1" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Kategori Kutuları */}
      <div className="flex flex-col items-center gap-4">
        {Object.keys(categoryVisuals).map((cat, index) => (
          <div
            key={index}
            onClick={() => handleOpen(cat)}
            className="relative w-85 sm:w-65 md:w-70 shadow-md rounded-xl overflow-hidden cursor-pointer transition hover:scale-105"
          >
            <img
              src={categoryVisuals[cat]}
              alt={cat}
              className="w-full h-auto object-contain"
            />
            <div className="absolute inset-0 bg-white bg-opacity-10 flex items-center justify-center">
              <span className="text-lg font-bold text-gray-800">{cat}</span>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default LeftSidebar;
